import { formComponents as fc } from "@/components/form";
import { filterSurgeryOptions } from "@/features/injection/utils/injectionOptions";
import type { SideZ } from "@/types/zod/common";
import { useWatch } from "@/utils/form";
import { useFormContext } from "react-hook-form";
import { useAnatomicRegionsQuery } from "../../../api/selectAnatomicRegions";
import { sideOptions } from "../../../utils/sideOptions";
import { useSelectSurgeryOptions } from "../api/selectSurgeryOptions";
import SurgeryOptionForm from "./SurgeryOptionForm";

interface FormValues {
	event_id: string;
	surgery_id: string;
	side: typeof SideZ._type;
	surgery_option_id: string;
	orthopaedic_area?: string;
}

interface Props {
	sideFieldName?: string;
	orthopaedicAreaFieldName?: string;
	surgeryOptionIdFieldName?: string;
}

export function SurgeryFormFields({
	sideFieldName = "side",
	orthopaedicAreaFieldName = "orthopaedic_area",
	surgeryOptionIdFieldName = "surgery_option_id",
}: Props) {
	const { control } = useFormContext<FormValues>();
	const { data: surgeryOptions } = useSelectSurgeryOptions();
	const { data: anatomicRegions } = useAnatomicRegionsQuery();

	const watch = useWatch({ control });

	return (
		<>
			<fc.Select
				name={sideFieldName}
				label="Side"
				options={sideOptions}
			/>

			<fc.Select
				autoFocus
				name={orthopaedicAreaFieldName}
				label="Anatomic Region"
				options={anatomicRegions?.map((ar) => ({
					label: ar.orthopaedic_area,
					value: ar.orthopaedic_area,
				})) ?? []}
			/>

			<fc.ComboBox
				options={filterSurgeryOptions(
					surgeryOptions ?? [],
					"orthopaedic_area",
					watch[orthopaedicAreaFieldName],
				) ?? []}
				name={surgeryOptionIdFieldName}
				label="Surgery"
				addOption={
					<SurgeryOptionForm
						anatomicRegion={watch[orthopaedicAreaFieldName]}
					/>
				}
			/>
		</>
	);
}
